<section [attr.aria-busy]="(accountTicketsLoaded$ | async) === false" aria-live="assertive">
    <div class="card-detail-view-area" *ngIf="(tickets$ | async)?.length > 0">
        <div class="card-list-table__travel-card-title">
            <h2>{{ 'TRAVEL_TICKETS_ON_EMAIL' | translate }}</h2>
        </div>

        <div class="card-list-table__travel-card"></div>

        <div class="card-detail-view-area-ticket">
            <rwidget-account-tickets-list
                [tickets]="tickets$ | async"
                [locale]="locale"
                (requestTicketAction)="ticketAction($event)"></rwidget-account-tickets-list>
        </div>
    </div>
</section>

<ridango-ui-basic-loading-spinner
    *ngIf="(accountTicketsLoaded$ | async) === false"
    [ariaLabel]="'LOADER_LOADING_ARIA_LABEL' | translate">
</ridango-ui-basic-loading-spinner>
